"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Model = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Model"));

// Generated by script, don't edit it please.
var Model = (0, _createSvgIcon["default"])({
  as: _Model["default"],
  ariaLabel: 'model',
  category: 'application',
  displayName: 'Model'
});
var _default = Model;
exports["default"] = _default;
module.exports = exports.default;